var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qrcode',{attrs:{"value":JSON.stringify(_vm.qr_code),"options":{ size: 150, foreground: '#0275d8'  }}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e6215cb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/qr-code/qr-code.html
// module id = null
// module chunks = 